import { cx } from "../../utils/cx";
import Spinner from "./Spinner";

// On/off toggle; `loading` shows a spinner in the knob and blocks clicks
export default function Switch({ checked, onChange, disabled = false, loading = false, label, className }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled || loading}
      onClick={() => onChange(!checked)}
      className={cx(
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-200",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/20 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60",
        checked ? "bg-brand" : "bg-slate-200",
        className
      )}
    >
      <span
        className={cx(
          "flex h-5 w-5 items-center justify-center rounded-full bg-white shadow transition-transform duration-200",
          checked ? "translate-x-[22px]" : "translate-x-0.5"
        )}
      >
        {loading && <Spinner className="h-3 w-3 text-brand" />}
      </span>
    </button>
  );
}
